'use strict';

var React = require('react');

var SvgReturnsMajor = function SvgReturnsMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 5h8l-1.845-2.571c-.192-.267-.546-.43-.928-.429h-5.227v3Zm-2-3h-5.227c-.382-.001-.736.162-.928.429l-1.845 2.571h8v-3Zm-8 5v10.5a1.5 1.5 0 0 0 1.5 1.5h6c1 0 1.5-1 1.5-1 0-.534.003-1.067.01-1.5 0-3.584 2.913-6.5 6.495-6.5h1.495s1 0 1-1v-2h-18Zm19 6a1 1 0 1 0-2 0v1a2 2 0 0 1-2 2h-.586l.293-.293a1 1 0 0 0-1.414-1.414l-2 2a1 1 0 0 0 0 1.414l2 2a1 1 0 0 0 1.414-1.414l-.293-.293h.586a4 4 0 0 0 4-4v-1Z"
  }));
};

exports.SvgReturnsMajor = SvgReturnsMajor;
